import { useTranslation } from 'react-i18next'

import { QA_NAME_MODAL_MINIMIZE_BTN } from '../../../constants/qa'
import { ButtonIconMinimize } from '../../Button'

function ModalMinimizeButton({ onClick, ...restProps }) {
  const { t } = useTranslation()

  return (
    <ButtonIconMinimize
      {...restProps}
      qaName={QA_NAME_MODAL_MINIMIZE_BTN}
      tooltip={t('Modal.MinimizeTooltipKey')}
      onClick={onClick}
    />
  )
}

export default ModalMinimizeButton
